import { DatePicker, Select, Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getInquiries } from '../../../api/boardParentsQna.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import Pagination from '../../../components/Pagination';
import SelectCampus from '../../../components/SelectCampus';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { getCommonCodeLabel } from '../../../lib/store';
import {
  IGetInquiries,
  IInquiryItem,
} from '../../../models/boardParentsQna.model';
import { RootState } from '../../../store/rootReducer';

const HomepageInquiry = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // BR0003 = 1:1문의 구분
  // const BR0003 = commonCodes.find((item) => item.commonCode === 'BR0003',)?.detailCode;
  // BR0004 = 1:1문의 상태
  const BR0004 = commonCodes.find(
    (item) => item.commonCode === 'BR0004',
  )?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetInquiries>();

  const [qnaDiv, setQnaDiv] = useState<string>();
  const [qnaStatus, setQnaStatus] = useState<string>();
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [title, setTitle] = useState('');
  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});
  const [data, setData] = useState<IInquiryItem[]>([]);

  useEffect(() => {
    execute(getInquiries());
  }, []);

  useEffect(() => {
    if (res && !isLoading && currentCampus) {
      const _param: any = {};
      let _data: IInquiryItem[] = _.cloneDeep(res.data);
      _data = _data.filter((item) => item.campusCode === currentCampus);

      if (query.page) {
        const _page = Number(query.page);
        setPage(_page);
        _param.page = _page;
      }
      if (query.qnaDiv) {
        const _qnaDiv = String(query.qnaDiv);
        setQnaDiv(_qnaDiv);
        _param.qnaDiv = _qnaDiv;
        _data = _data.filter((item) => item.qnaDiv === _qnaDiv);
      }
      if (query.qnaStatus) {
        const _qnaStatus = String(query.qnaStatus);
        setQnaStatus(_qnaStatus);
        _param.qnaStatus = _qnaStatus;
        _data = _data.filter((item) => item.qnaStatus === _qnaStatus);
      }
      if (query.startDate && query.endDate) {
        const _startDate = String(query.startDate);
        const _endDate = String(query.endDate);
        setStartDate(_startDate);
        setEndDate(_endDate);
        _param.startDate = _startDate;
        _param.endDate = _endDate;
        _data = _data.filter(
          (item) =>
            moment(item.regDate).isAfter(String(query.startDate)) &&
            moment(item.regDate).isBefore(String(query.endDate)),
        );
      }
      if (query.title) {
        const _title = String(query.title);
        setTitle(_title);
        _param.title = _title;
        _data = _data.filter((item) => item.title.includes(_title));
      }

      setParam(_param);
      setData(_data);
    }
  }, [res, isLoading, location, currentCampus]);

  const onSearch = () => {
    const param: any = { page: 1 };
    param.campusCode = currentCampus;
    if (qnaDiv) param.qnaDiv = qnaDiv;
    if (qnaStatus) param.qnaStatus = qnaStatus;
    if (startDate && endDate) {
      param.startDate = moment(startDate).format('YYYYMMDD');
      param.endDate = moment(endDate).format('YYYYMMDD');
    }
    if (title) param.title = title;

    history.push(`/homepage/inquiry?${QueryString.stringify(param)}`);
  };

  const columns: TableColumnsType<IInquiryItem> = [
    {
      title: t('homepage.archive.column1'),
      dataIndex: 'qnaCode',
      key: 'qnaCode',
      width: '6%',
      sorter: (a, b) => a.qnaCode - b.qnaCode,
    },
    // {
    //   title: '구분',
    //   dataIndex: 'qnaDiv',
    //   key: 'qnaDiv',
    //   sorter: (a, b) => a.qnaDiv?.localeCompare(b.qnaDiv),
    //   render: (value) => getCommonCodeLabel('BR0003', value, 'ko'),
    // },
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title?.localeCompare(b.title),
      ellipsis: true,
      render: value => {
        return <div className="text-left ant-table-cell-ellipsis">{value}</div>
      }
    },
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusCode',
      key: 'campusCode',
      width: '7%',
      sorter: (a, b) => a.campusCode?.localeCompare(b.campusCode),
      render: (value: string) => {
        const campus = campusData?.find((item) => item.campusCode === value);
        return campus ? campus.campusKorName : value;
      },
    },
    {
      title: t('homepage.archive.column6'),
      dataIndex: 'regMemKorName',
      key: 'regMemKorName',
      width: '10%',
      sorter: (a, b) => a.regMemKorName?.localeCompare(b.regMemKorName),
    },
    {
      title: t('homepage.archive.column5'),
      dataIndex: 'regDate',
      key: 'regDate',
      width: '10%',
      sorter: (a, b) => a.regDate?.localeCompare(b.regDate),
      render: (value: string) => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('homepage.inquiry.column1'),
      dataIndex: 'qnaStatus',
      key: 'qnaStatus',
      width: '10%',
      sorter: (a, b) => a.qnaStatus?.localeCompare(b.qnaStatus),
      render: (value, record) => {
        const status = getCommonCodeLabel('BR0004', value, 'ko');
        const date = record.answerDate
          ? `(${moment(record.answerDate).format('YYMMDD')})`
          : null;
        return date ? (
          <>
            {status} {date}
          </>
        ) : (
          status
        );
      },
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-homepage-big.svg"
      parentMenu={t('common.menu.homepage')}
      currentMenu={t('homepage.inquiry.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('homepage.inquiry.column1')}</label>
            <div>
              <Select
                placeholder={t('homepage.inquiry.column1')}
                value={qnaStatus}
                onChange={(value) => setQnaStatus(value)}
              >
                {BR0004?.map((item) => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('archive.learn.column2')}</label>
            <div className="date-picker__area">
              <DatePicker
                value={startDate ? moment(startDate) : undefined}
                onChange={(e) => {
                  if (e === null) setStartDate('');
                  else setStartDate(moment(e).format('YYYYMMDD'));
                }}
              />
              ~
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={(e) => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'));
                }}
              />
            </div>
          </li>
          <li>
            <label>{t('common.column.title')}</label>
            <input
              type="text"
              className="form-control w-150p"
              placeholder={t('homepage.inquiry.placeholder1')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{data?.length || 0}</b>{t('common.text.unit')}
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  history.push(
                    `/homepage/inquiry/${record.qnaCode}${location.search}`,
                  );
                },
              };
            }}
            rowClassName={(record) =>
              'pointer' + (record.qnaStatus === 'FI' ? ' chosen' : '')
            }
            rowKey="qnaCode"
          />
        </div>
        <div className="comm-bx__between">
          <div className="common-paging center">
            <Pagination
              count={data?.length || 0}
              page={page}
              param={param}
              path="/homepage/inquiry"
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default HomepageInquiry;
